import { Box, Flex, keyframes, BoxProps } from '@chakra-ui/react';

const spinAnimation = keyframes`
0% {
  transform: rotate(0deg);
}
50% {
  transform: rotate(22.5deg);
}
100% {
  transform: rotate(45deg);
}
`;

const GearPart = ({ sx, ...props }: BoxProps) => (
  <Box
    sx={{
      boxSizing: 'content-box',
      position: 'absolute',
      w: 33.63,
      h: 134.52,
      bg: 'primaryThemeColour.400',
      left: 88.5,
      top: 88.5,
      transform: 'translate(-50%, -50%)',
      ...sx,
    }}
    {...props}
  />
);

const AppLoader = () => (
  <Flex
    sx={{
      h: '100vh',
      w: '100vw',
      justifyContent: 'center',
      alignItems: 'center',
      bg: 'blackAlpha.700',
    }}
    data-testid="app-loader"
  >
    <Box
      sx={{
        w: 177,
        h: 177,
        display: 'inline-block',
        overflow: 'hidden',
        bg: 'none',
      }}
    >
      <Box
        sx={{
          w: 'full',
          h: 'full',
          position: 'relative',
          transform: 'translateZ(0) scale(0.8)',
          backfaceVisibility: 'hidden',
          transformOrigin: '0 0',
        }}
      >
        <Box
          transformOrigin="88.5px 88.5px"
          boxSizing="content-box"
          animation={`${spinAnimation} 0.5319148936170213s infinite linear`}
        >
          <GearPart
            sx={{
              w: 106,
              h: 106,
              borderRadius: '50%',
            }}
          />
          <GearPart />
          <GearPart
            sx={{
              transform: 'translate(-50%, -50%) rotate(45deg)',
            }}
          />
          <GearPart
            sx={{
              transform: 'translate(-50%, -50%) rotate(90deg)',
            }}
          />
          <GearPart
            sx={{
              transform: 'translate(-50%, -50%) rotate(135deg)',
            }}
          />
          <GearPart
            sx={{
              w: 53,
              h: 53,
              bg: 'blackAlpha.300',
              borderRadius: '50%',
              opacity: 1,
            }}
          />
        </Box>
      </Box>
    </Box>
  </Flex>
);

export default AppLoader;
